import React, { FC, useEffect } from 'react';
import { ReactComponent as XCircleIcon } from 'bootstrap-icons/icons/x-circle.svg';
import styles from './autoResizableInput.module.scss';

export const AutoResizableInput: FC<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    clearable?: boolean;
    onClear?: () => void;
  }
> = (props) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const hideRef = React.useRef<HTMLSpanElement>(null);

  function resize() {
    // @ts-ignore
    if (hideRef.current.offsetWidth < 100) return;
    // @ts-ignore
    inputRef.current.style.width = hideRef.current.offsetWidth + 'px';
  }

  useEffect(() => {
    resize();
  }, [props.value, props?.clearable, props?.onClear]);

  return (
    <>
      <span
        className={`${styles.Hide} tw-text-xl sm:tw-text-2xl px-3 text-center border border-1 border-gray`}
        ref={hideRef}
      >
        {props.value}
      </span>
      {!props?.clearable ? (
        <input {...props} className={`${styles.Txt} ${props.className}`} type="text" ref={inputRef} />
      ) : (
        <div className="tw-flex tw-items-center tw-relative">
          <input
            {...props}
            className={`${styles.Txt} ${props.className} px-0 tw-px-0 pe-4`}
            type="text"
            ref={inputRef}
          />
          <XCircleIcon
            className="tw-cursor-pointer tw-absolute tw-right-1.5 tw-top-2 hover:!tw-scale-[1.1] !tw-transition-all"
            onClick={props.onClear}
          ></XCircleIcon>
        </div>
      )}
    </>
  );
};
